import { useStore } from 'vuex';
import { computed } from 'vue';

function useDialog() {
	const store = useStore();
	const visible = computed(() => store.state.commonVisible);
	const type = computed(() => store.state.tipType);
	const handleOpenDialog = (type) => {
		store.commit('toggleCommonVisible', true);
		store.commit('setTipType', type);
	};
	const handleCloseDialog = () => {
		store.commit('toggleCommonVisible', false);
	};
	return {
		visible,
		type,
		handleOpenDialog,
		handleCloseDialog,
	};
}

export default useDialog;
